module.exports = __webpack_public_path__ + "static/img/pic_belle@2x.841e100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/pic_belle@2x.png
// module id = I6Ut
// module chunks = 0